import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef, useImperativeHandle, useRef, useCallback, useContext } from 'react';
import './Select.sass';
import { isTouchDevice } from '../../utils';
import { useLoadingIndicatorDelay } from '../../hooks';
import { SvgCaretDown, SvgSpinner } from '../../index';
import { TertiaryBtn } from '../btn/TertiaryBtn';
import { Icon, SIZE } from '../icon/Icon';
import { FormItemContext } from '../form/FormItem';
const fakeClick = () => {
    // TertiaryBtn is used for visual purpouse
};
export const Select = forwardRef(({ value, name, items, hasEmptyItem, isDisabled, isRequired, isInvalid: isInvalidProp, isHovered, testId, onChange, }, ref) => {
    const formItemContext = useContext(FormItemContext);
    const selectRef = useRef(null);
    const showLoadingIndicator = useLoadingIndicatorDelay();
    const isLoading = items.length < 1 && showLoadingIndicator;
    useImperativeHandle(ref, () => ({
        focus: () => {
            if (!isTouchDevice()) {
                selectRef.current?.focus();
            }
        },
    }));
    const handleChange = useCallback((e) => {
        onChange(e, { name: name, value: e.target.value });
    }, [name, onChange]);
    const isInvalid = isInvalidProp || formItemContext.isInvalid;
    const classNames = items.length < 1 ? ' sg-select-isLoading' : '';
    return (_jsxs("div", { className: 'sg-select' + classNames, children: [_jsxs("select", { id: formItemContext.id, ref: selectRef, className: 'sg-select--element', name: name, value: value, disabled: isDisabled, required: isRequired, onChange: handleChange, "aria-describedby": formItemContext.descriptionId, "aria-invalid": isInvalid, "data-hovered": isHovered, "data-test-id": testId, children: [hasEmptyItem && _jsx("option", { value: '' }, '-1'), items.map((item, idx) => (_jsx("option", { value: item.value, children: item.label }, idx)))] }), _jsx("span", { className: 'sg-select--arrow', children: isLoading ? (_jsx(Icon, { element: _jsx(SvgSpinner, {}), size: SIZE.MED })) : (_jsx(TertiaryBtn, { icon: { element: _jsx(SvgCaretDown, {}) }, tabIndex: -1, onClick: fakeClick })) })] }));
});
//# sourceMappingURL=Select.js.map